/**
 * Logger condicional que solo muestra logs en desarrollo
 */
const isDevelopment = import.meta.env.DEV;

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  error: (...args: any[]) => {
    // Los errores siempre se registran, pero en producción se pueden enviar a un servicio
    if (isDevelopment) {
      console.error(...args);
    } else {
      // En producción, aquí se podría enviar a un servicio de logging
      // Por ahora, solo no mostrar en consola
    }
  },
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
};

